import React from 'react';
import { Order } from '@hero/schema';
import { ShipmentDetails } from './ShipmentDetails';
import { LoadDetails } from './LoadDetails';
import { DriverDetails } from './DriverDetails';
import { VehicleDetails } from './VehicleDetails';
import { OrderPriceDetails } from './OrderPriceDetails';
import { OrderRouteDetails } from './OrderRouteDetails';
import { GovernmentWaybillDetails } from './GovernmentWaybillDetails';
import type { OrderDisplayPriceUi } from '@hero/hooks-shared';

export interface OrderDetailsTabProps {
  order: Order;
  priceUi: OrderDisplayPriceUi;
}

export const OrderDetailsTab: React.FC<OrderDetailsTabProps> = ({ order, priceUi }) => {
  return (
    <div className="space-y-4">
      <OrderPriceDetails priceUi={priceUi} />
      <OrderRouteDetails order={order} />
      <ShipmentDetails order={order} />
      <LoadDetails order={order} />
      <DriverDetails order={order} />
      <VehicleDetails order={order} />
      {/* Last because it depends on the driver and truck above — when it shows
          a blocker, the record that needs fixing is right there. Renders
          nothing at all for Orgs with no Bayan account. */}
      <GovernmentWaybillDetails order={order} />
    </div>
  );
};
